package dev.danko.roblox_craft_ai.shared.model

import kotlinx.serialization.Serializable

@Serializable
data class SessionSync(
    val token: String,
    val activeAssets: List<AssetResponse> = emptyList()
)
